import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import { MissionPartner } from "../../../../../../api/sign-up/signup.types";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Observable, Subject, takeUntil} from "rxjs";
import {CmsNameValue, compareCmsNameValue} from "../../../../../../api/cms/cms.types";
import {CmsCachedService} from "../../../../../../api/cms/cms-cached.service";

@Component({
  selector: "mh-profile-compliance-kpi",
  templateUrl: "./profile-compliance-kpi.component.html",
  styleUrls: ["./profile-compliance-kpi.component.less"],
})
export class ProfileComplianceKpiComponent implements OnInit, OnDestroy{
  @Input() missionPartner!: MissionPartner;
  @Output() formChange = new EventEmitter<MissionPartner>();
  @Output() submitChange = new EventEmitter<void>();

  public formGroup!: FormGroup;
  private readonly destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.formGroup = this.fb.group({
      complianceKpi: this.fb.group({
        kpiPossibleWorkingAssignments: [this.missionPartner.complianceKpi.kpiPossibleWorkingAssignments, []],
        kpiPercentagePartTimeLeadership: [this.missionPartner.complianceKpi.kpiPercentagePartTimeLeadership, []],
        kpiPercentageFemaleLeadership: [this.missionPartner.complianceKpi.kpiPercentageFemaleLeadership, []],
        kpiQuestion1: [this.missionPartner.complianceKpi.kpiQuestion1, []],
        kpiQuestion2: [this.missionPartner.complianceKpi.kpiQuestion2, []],
        kpiQuestion3: [this.missionPartner.complianceKpi.kpiQuestion3, []],
        kpiQuestion4: [this.missionPartner.complianceKpi.kpiQuestion4, []],
        kpiQuestion5: [this.missionPartner.complianceKpi.kpiQuestion5, []],
        kpiQuestion6: [this.missionPartner.complianceKpi.kpiQuestion6, []],
        kpiQuestion7: [this.missionPartner.complianceKpi.kpiQuestion7, []],
        kpiQuestion8: [this.missionPartner.complianceKpi.kpiQuestion8, []],
        kpiQuestion9: [this.missionPartner.complianceKpi.kpiQuestion9, []],
        kpiQuestion10: [this.missionPartner.complianceKpi.kpiQuestion10, []],
      }),
    });
    this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) =>
      this.formChange.emit({
        ...this.missionPartner,
        complianceKpi: {
          ...this.missionPartner.complianceKpi,
          ...value.complianceKpi,
        },
      }),
    );
  }

  isStepValid(): boolean {
    if (this.formGroup.invalid) {
      Object.values(this.formGroup.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
    return this.formGroup.valid;
  }

  submitForm() {
    if(!this.isStepValid()) return;
    this.submitChange.emit();
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  protected readonly compareCmsNameValue = compareCmsNameValue;
}
